import { type FilterItem } from 'widgets/FilterEditor/model'

export const HubspotTypes = new Set(['hubspot', 'hubspot-lists'])

export const isHubspotWidget = (filterItem: FilterItem) =>
  HubspotTypes.has(filterItem.type || filterItem.key)
